export default __webpack_public_path__ + "static/media/1_0074.540e19aa.webp";